module.exports = __webpack_public_path__ + "img/pole-light-status-green@2x.af91cd3d.webp";